var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cooperate"},[_c('h2',[_vm._v("可靠和值得信赖的合作伙伴")]),_c('p',[_c('span',[_c('img',{attrs:{"src":require("@/assets/images/address.png")}}),_vm._v(" 地址：北京市朝阳区联合大厦1604 ")]),_c('span',[_c('img',{attrs:{"src":require("@/assets/images/phone.png")}}),_vm._v(" 电话：18210566607,13811973070 ")])])])
}]

export { render, staticRenderFns }